import React from 'react'
import "../../../styles/clientes/nuestros_clientes.css"
import Logo from "../../Reutilizables/Logo"
import Menu from "../../Reutilizables/Menu"
import MenuInicioSuscrito from '../inicioSuscrito/MenuInicioSuscrito';
import Redes from "../../Reutilizables/Redes"
import Footer from '../../Reutilizables/Footer'
import TituloImpuestosMunicipales from "../../Reutilizables/TituloImpuestosMunicipales"

function Nuestros_clientes({ user }) {

  return (
   <div className='bodyClientes'>
    <div className='container-logo-menu-clientes'> 
    	<Logo />
		
        {
          user ? <MenuInicioSuscrito /> : <Menu />
        }

    </div>
	<TituloImpuestosMunicipales />
	<Redes />
		<div className="calendar-frame center">
			<div className="day-frame center real" id='one'>
				<div className="day-label center">ALCALDÍA DE BUENAVENTURA</div>
			</div>
			<div className="day-frame center real" id='two'>
				<div className="day-label center">ALCALDÍA DE VITERBO - CALDAS</div>
			</div>
			<div className="day-frame center real" id='three'>
				<div className="day-label center">ALCALDÍA DE CALARCÁ - QUINDÍO</div>
			</div>
			<div className="day-frame center real" id="four">
				<div className="day-label center">ALCALDÍA TEBAIDA - QUINDÍO</div>
			</div>
			<div className="day-frame center real" id='five'>
				<div className="day-label center">ALCALDÍA DE LA VICTORIA</div>
			</div>
			<div className="day-frame center real" id='six'>
				<div className="day-label center">ALCALDÍA DE CARTAGO VALLE</div>
			</div>
			<div className="day-frame center real" id='seven'>
				<div className="day-label center">ALCALDÍA DE ZARZAL VALLE</div>
			</div>
			<div className="day-frame center real" id='eight'>
				<div className="day-label center">ALCALDÍA DE BOLÍVAR VALLE</div>
			</div>
			<div className="day-frame center real" id='nine'>
				<div className="day-label center">ALCALDÍA DE RIOFRÍO VALLE</div>
			</div>
			<div className="day-frame center real" id='ten'>
				<div className="day-label center">ALCALDÍA DE GUACARÍ - VALLE</div>
			</div>
			<div className="day-frame center real" id='eleven'>
				<div className="day-label center">ALCALDÍA DE RESTREPO</div>
			</div>
			<div className="day-frame center real" id='twelve'>
				<div className="day-label center">ALCALDÍA DE PALMIRA - VALLE</div>
			</div>
			<div className="day-frame center real" id='thirteen'>
				<div className="day-label center">ALCALDÍA DE MIRANDA CAUCA</div>
			</div>
			<div className="day-frame center real" id='fourteen'>
				<div className="day-label center">ALCALDÍA DE FLORIDA VALLE</div>
			</div>
			<div className="day-frame center real" id='fifteen'>
				<div className="day-label center">ALCALDÍA DE CANDELARIA VALLE</div>
			</div>
			<div className="day-frame center real" id='sixteen'>
				<div className="day-label center">ALCALDÍA DE QUIBDÓ CHOCO</div>
			</div>
			<div className="day-frame center real" id='seventeen'>
				<div className="day-label center">ALCALDÍA DE BUGALAGRANDE</div>
			</div>
			<div className="day-frame center real" id='eighteen'>
				<div className="day-label center">ALCALDÍA DE CERRITO VALLE</div>
			</div>
			<div className="day-frame center real" id='nineteen'>
				<div className="day-label center">ALCALDÍA DE ROLDANILLO</div>
			</div>
			<div className="day-frame center real" id='twenty'>
				<div className="day-label center">ALCALDÍA DE PRADERA VALLE</div>
			</div>
			<div className="day-frame center real" id='twenty-one'>
				<div className="day-label center">ALCALDÍA DE DOSQUEBRADAS</div>
			</div>
			<div className="day-frame center real" id='twenty-two'>
				<div className="day-label center">ALCALDÍA DE SANTAROSA</div>
			</div>
			<div className="day-frame center real" id='twenty-three'>
				<div className="day-label center">FLORENCIA</div>
			</div>
			<div className="day-frame center real" id='twenty-four'>
				<div className="day-label center">CAICEDONIA</div>
			</div>
			<div className="day-frame center real" id='twenty-five'>
				<div className="day-label center">PUERTO RICO</div>
			</div>
			<div className="day-frame center real" id='twenty-six'>
				<div className="day-label center">SAN VICENTE DEL CAGUÁN</div>
			</div>
			<div className="day-frame center real" id='twenty-seven'>
				<div className="day-label center">CARTAGENA DE CHAIRA</div>
			</div>
		</div>
		<Footer />
	</div> 
  )
}

export default Nuestros_clientes